export const config = {
	btn: {
		elevation: 0,
		height: 'auto',
		color: 'transparent'
	},
	icon: {
		class: 'mr-2'
	}
};
